import { setDirections, setDirectionsPanel, setShowQRFrame, } from '../../../../../store/uislice';
import { store } from '../../../../../store/store';
import { setSelectedLocation } from '../../../redux/spaces-slice';
import { sendTrackingEventForGetDirectionsClick } from '../../util';
import { invokeRichMapMethod } from './rich-map';
const startDirections = ({ currentFloorLocationId, deviceFloorNumber, deviceLocationId, drawingOnMap, richMapId, roomFloorNumber, roomName, tenantId, }) => {
    if (!richMapId) {
        return;
    }
    store.dispatch(setShowQRFrame({ payload: false }));
    store.dispatch(setDirections({ payload: null }));
    sendTrackingEventForGetDirectionsClick(richMapId, tenantId);
    if (drawingOnMap && roomFloorNumber !== deviceFloorNumber) {
        // Store the real rich map id (still used verbatim for rMap.navigate) plus
        // the authoritative name/floor so the stepper renders from these instead of
        // splitting the rich map id.
        store.dispatch(setDirectionsPanel({
            payload: {
                richMapId,
                name: roomName !== null && roomName !== void 0 ? roomName : null,
                floorNumber: roomFloorNumber,
            },
        }));
        if (deviceLocationId &&
            currentFloorLocationId &&
            currentFloorLocationId !== deviceLocationId) {
            store.dispatch(setSelectedLocation(deviceLocationId));
        }
        return;
    }
    if (!drawingOnMap) {
        return;
    }
    invokeRichMapMethod('reset');
    window.setTimeout(() => {
        invokeRichMapMethod('navigate', richMapId);
    }, 200);
};
export { startDirections };
